import { UIHeading2, useDeviceType } from '@cian/ui-kit';
import { clsx as cx } from 'clsx';
import * as React from 'react';

import * as styles from './CalculateResult.css';
import { BlockListItem } from './components/BlockListItem';
import { TYPE_TO_ICON_CLASS_MAP } from './constants';
import { EConclusion, IResultBlock, EBlockType } from '../../types/calculate';

interface ICalculateResultProps {
  type: EConclusion;
  title: string;
  blocks: IResultBlock[];
  links: React.ReactNode;
}

const ProfitableCheckList: {
  [key: string]: string | undefined;
} = {
  [EConclusion.DepositProfitable]: EBlockType.Deposit,
  [EConclusion.MortgageProfitable]: EBlockType.Mortgage,
};

export const CalculateResult: React.VFC<ICalculateResultProps> = ({ type, title, blocks, links }) => {
  const deviceType = useDeviceType();
  const isProfitable = (blockType: EBlockType) => ProfitableCheckList[type] === blockType;

  return (
    <div className={cx(styles['container'], styles[`container--${deviceType}`])}>
      <div className={cx(styles['header'], styles[`header--${TYPE_TO_ICON_CLASS_MAP[type]}`])}>
        <UIHeading2>{title}</UIHeading2>
      </div>
      {blocks.length > 0 && (
        <ul className={styles['blocks-list']}>
          {blocks.map(({ title, price, time, type: blockType }) => (
            <BlockListItem
              type={blockType}
              key={`block__${title}`}
              title={title}
              price={price}
              time={time}
              deviceType={deviceType}
              profitable={isProfitable(blockType)}
            />
          ))}
        </ul>
      )}
      {links && <div className={styles['bottom-links']}>{links}</div>}
    </div>
  );
};
